import { makeStyles } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import actions from './redux/actions'

const useStyles = makeStyles((theme) => ({
  notification: {
    position: 'fixed',
    display: 'flex',
    zIndex: 4,
    top: '10%',
    left: 0,
    right: 0,
    margin: 'auto',
    width: 'max-content',
    fontSize:'inherit',
    border: '1px solid'
  },
}))

const SystemAlerts = (props) => {
  const alerts = useSelector((state) => state.alert.alerts)
  const dispatch = useDispatch()
  const closeAlert = (id) => dispatch(actions.alerts.closeAlert({ id }))

  const classes = useStyles()
  if (!alerts) return null
  return (
    <>
      {alerts.map((alert, i) => {
        const { variant, component, message, id, permanent } = alert
        const handleClose = permanent ? undefined : () => closeAlert(id)
        return (
          <Alert
            key={`alert${i}`}
            style={{marginTop: (i * 6) + 'rem'}}
            className={classes.notification}
            open={true}
            severity={variant}
            children={component}
            {...(handleClose ? {onClose:handleClose} : {})}
          />
        )
      })}
    </>
  )
}

export default SystemAlerts
